import { request } from "./request";
import { sendError } from "../errors";
import { getConfig } from "../services/config";

const BASE_URL = "https://api.mapbox.com";

export default {
  async lookupAddress(address) {
    const params = new URLSearchParams();
    params.append("access_token", getConfig("mapboxAccessToken"));
    try {
      const response = await request(
        `${BASE_URL}/geocoding/v5/mapbox.places/${encodeURIComponent(
          address
        )}.json`,
        params
      );
      const [lng, lat] = response.features[0].center;
      return { lng, lat };
    } catch (err) {
      sendError(err);
    }
  },
};
